
import Vue from 'vue'
import Vuex from 'vuex'
// 使用vuex
Vue.use(Vuex)
// 创建一个store仓库
const store = new Vuex.Store({
  state: {
    userInfo: {}
  },
  getters: {},
  mutations: {
    userInfo (state, value) {
      state.userInfo = value
    }
  },
  actions: {},
  // 添加模块
  modules: {},
  // 开启严格模式，仅需在创建 store 的时候传入 strict: true：
  // strict: process.env.NODE_ENV !== 'production'
  strict: false
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js